(function ($) {
  'use strict';

  /**
   * Site header + hero offset
   */

  // On load - Update Var
  updateHeaderOffsetCssVar();

  // On screen size change - Update var
  $(window).on( 'resize', updateHeaderOffsetCssVar );

  // Get the site header height & add CSS offset var to first hero or section on page
  function updateHeaderOffsetCssVar() {
    var $first_hero = $( '.site-main > .section-hero:first-child, .site-main > .section:first-child' );
    var $site_header = $('.site-header-wrap');
    var site_header_height = $site_header.height() / 16; // converts px to rem

    // Page Load - Add header spacing offset css var
    $first_hero.each(function () {
      $(this).css( '--header-height-offset', site_header_height + 'rem' );
    });
  }

})(jQuery);
